export default {"src":"/_next/static/media/generic-thumbnail-ppt.e87344c7.svg","height":92,"width":66,"blurWidth":0,"blurHeight":0};